import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import locale from '../node_modules/element-ui/lib/locale/lang/en'
import 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui'
import axios from 'axios'

axios.defaults.baseURL = 'http://43.159.142.225:8087'
// axios.defaults.baseURL = 'http://localhost:8087'

Vue.prototype.$http = axios

Vue.config.productionTip = false
// Vue.use(ElementUI)
Vue.use(ElementUI,{locale})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
